import { StringParam, UrlUpdateType, useQueryParam, withDefault } from 'use-query-params';

export const SEARCH_QUERY_KEY = 'zoekterm';

type NewValueType<D> = D | ((latestValue: D) => D);

export type UseSearchReturn = {
	searchValue: string | null;
	setSearchValue: (newValue: NewValueType<string | null | undefined>, updateType?: UrlUpdateType | undefined) => void;
};

export const useSearch = (): UseSearchReturn => {
	const [searchValue, setSearchValue] = useQueryParam(SEARCH_QUERY_KEY, withDefault(StringParam, null));

	return {
		searchValue,
		setSearchValue
	};
};
